import { useState } from "react";
import { Box, Menu, Center, Text, MenuButton, useDisclosure, MenuList, MenuItem, MenuItemProps } from "@chakra-ui/react";
import { DropdownIcon } from "components";
import { useCurrencyFlag } from "hooks";
import configs from "config";

interface Props extends MenuItemProps {
  handleMenuItem: (el: string) => void;
  coinSelected: string;
  wallet: string[];
  shouldOpen?: boolean;
}

interface CountryCurrency {
  [key: string]: string;
}
const SelectWithImage = ({ wallet, coinSelected, handleMenuItem, shouldOpen, ...props }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const flag = useCurrencyFlag();

  const [selected, setSelected] = useState(coinSelected);

  const handleOpen = (e: any) => {
    e.preventDefault();
    onOpen();
  };

  const country: CountryCurrency = {
    kes: "Kenyan Shillings",
    ngn: "Nigeria Naira",
    ghs: "Ghanaian Cedi",
  };

  return (
    <Menu isOpen={isOpen} onClose={onClose}>
      <MenuButton
        isolation="auto"
        disabled={shouldOpen === false ? true : false}
        _disabled={{
          cursor: "not-allowed",
        }}
        onClick={handleOpen}
        width="100%"
        transition="all 0.2s"
        borderRadius="10px"
        padding="8px"
        _hover={{
          borderColor: "var(--bitmama-colors-primary-600)",
          bg: "var(--bitmama-colors-gray-200)",
          borderWidth: "1.4px",
        }}
        _focus={{
          borderColor: "var(--bitmama-colors-primary-600)",
          borderWidth: "1.4px",
          boxShadow: "var(--bitmama-shadows-outline)",
        }}
      >
        <Center height="24px" gridGap="8px" alignItems="center">
          <Box>{flag(selected)}</Box>

          <Text fontSize="14px" fontWeight="500" textTransform="uppercase" fontFamily="var(--bitmama-fonts-heading)">
            {configs.fiats.includes(selected) ? "" : selected} {country[selected]}
          </Text>

          <DropdownIcon />
        </Center>
      </MenuButton>

      <MenuList minW="110px" height="auto" padding="0 !important">
        {wallet.map((el, idx) => {
          return (
            <MenuItem
              key={idx}
              alignItems="center"
              width="100%"
              padding="8px 12px"
              fontFamily="var(--bitmama-fonts-heading)"
              onClick={() => {
                setSelected(el);
                handleMenuItem(el);
              }}
              {...props}
              mb="4px"
            >
              <Center alignItems="center">
                <Box width="30px">{flag(`${el}`)}</Box>

                <Box color="#303131" fontWeight="600" fontSize="15px">
                  <>
                    {configs.fiats.includes(el) ? (
                      ""
                    ) : (
                      <Box>
                        {el === "ceur" || el === "cusd" ? (
                          <Text
                            textTransform="uppercase"
                            whiteSpace="nowrap"
                            css={{
                              "&::first-letter": {
                                textTransform: "lowercase",
                              },
                            }}
                          >
                            {el}
                          </Text>
                        ) : (
                          <Text as="span" textTransform="uppercase">
                            {el}
                          </Text>
                        )}
                      </Box>
                    )}

                    {country[el]}
                  </>
                </Box>
              </Center>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
export default SelectWithImage;
